import React from 'react';

export default () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <path d='M8 1.146a6.854 6.854 0 0 1 0 13.708A6.862 6.862 0 0 1 1.146 8 6.854 6.854 0 0 1 8 1.146zm0 1.458a5.396 5.396 0 1 0 0 10.792A5.396 5.396 0 0 0 8 2.604zM8 3.93a.73.73 0 0 1 .73.73v2.466c0 .08.064.146.145.146h2.466a.73.73 0 0 1 0 1.458H8.875a.146.146 0 0 0-.146.146v2.466a.73.73 0 0 1-1.458 0V8.875a.146.146 0 0 0-.146-.146H4.659a.73.73 0 0 1 0-1.458h2.466c.08 0 .146-.065.146-.146V4.659A.73.73 0 0 1 8 3.929z' />
  </svg>
);
